import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// External components
import MultiselectInput from "@/components/multiselectInput/multiselectInput";

@Component({ components: { MultiselectInput } })
export default class EditUserInfo extends Vue {
  @Action action_updateNormalUserInformation;

  @Getter getUser;

  @Mutation SPINNER;

  isEditingUserInfo = true;
  userForm = {
    first_name: "",
    last_name: "",
    document_type: "cc",
    document_number: "",
    cellphone: "",
    email: "",
  };
  documentTypes = ["cc", "ce"];

  get missingInformation() {
    const { first_name, last_name, document_type, document_number, cellphone, email } =
      this.userForm;
    const response = [];
    if (!first_name || !first_name.length) response.push("first_name");
    if (!last_name || !last_name.length) response.push("last_name");
    if (!document_type || !document_type.length || !document_number || !document_number.length)
      response.push("document");
    if (!cellphone || !cellphone.length) response.push("cellphone");
    if (!email || !email.length) response.push("email");
    return response;
  }

  get isEmailValid() {
    const { email } = this.userForm;
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  mounted() {
    this.setInitialData();
  }

  setInitialData() {
    this.isEditingUserInfo = false;
    this.userForm = { ...this.getUser };
    if (!this.userForm.document_type) this.userForm.document_type = "CC";
  }

  async updateUserInfo() {
    const { document_type, document_number, email } = this.userForm;
    if (!this.missingInformation.length && this.isEmailValid) {
      const payload = { normal_user: { document_type, document_number, email } };
      try {
        this.SPINNER(true);
        await this.action_updateNormalUserInformation(payload);
        this.isEditingUserInfo = false;
      } catch (error) {
        this.$swal({
          title: "Error",
          text: `Hubo un error al actualizar la información del usuario. ${
            error.response && error.response.data && error.response.data.message
          }`,
        });
      }
      this.SPINNER(false);
    }
  }

  isMissingInformation(informationName) {
    return this.missingInformation.find((info) => info === informationName);
  }
}
